import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { openReplayStateLogger } from '../../../hooks/open-replay';

export type UpliftMode = 'median' | 'percentile';

export interface SalaryToggles {
  role: boolean;
  seniority: boolean;
  geo: boolean;
  company: boolean;
}

export const DEFAULT_TOGGLES: SalaryToggles = {
  role: true,
  seniority: true,
  geo: true,
  company: false,
};

interface SalaryControlsState {
  simulatedSalary: number | null;
  upliftMode: UpliftMode;
  userPercentile: number | null;

  setSimulatedSalary: (value: number | null) => void;
  setUpliftMode: (mode: UpliftMode) => void;
  setUserPercentile: (percentile: number | null) => void;

  /** Reset all controls to defaults */
  reset: () => void;
}

export const useSalaryControlsStore = create<SalaryControlsState>()(
  devtools(
    openReplayStateLogger(
      (set) => ({
        simulatedSalary: null,
        upliftMode: 'percentile',
        userPercentile: null,

        setSimulatedSalary: (value) => set({ simulatedSalary: value }),
        setUpliftMode: (mode) => set({ upliftMode: mode }),
        setUserPercentile: (percentile) => set({ userPercentile: percentile }),

        reset: () =>
          set({
            simulatedSalary: null,
            upliftMode: 'percentile',
            userPercentile: null,
          }),
      }),
      'salary_controls'
    ),
    { name: 'SalaryControls' }
  )
);
